module.exports = __webpack_public_path__ + "img/insurance.c685bed0.svg";